import styled from "styled-components";

// 추후 실제 기본 이미지를 쓰고 싶으면 이 값에 정적 import 또는 URL을 넣으면 된다.
// 값이 있으면 아래 SVG 대신 해당 이미지를 보여준다.
//   예) import placeholder from "assets/no-image.png";
//       const PLACEHOLDER_SRC = placeholder;
const PLACEHOLDER_SRC = null;

const toSize = (size) => (typeof size === "number" ? `${size}px` : size);

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  border-radius: ${({ $radius }) => $radius};
  border: ${({ $bordered }) =>
    $bordered ? "1px solid var(--admin-gray-stroke, #e8e8e8)" : "none"};
  background-color: ${({ $color }) => $color};
  color: ${({ $iconColor }) => $iconColor};
  flex-shrink: 0;
  overflow: hidden;
`;

const Img = styled.img`
  width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
  border-radius: ${({ $radius }) => $radius};
  border: ${({ $bordered }) =>
    $bordered ? "1px solid var(--admin-gray-stroke, #e8e8e8)" : "none"};
  object-fit: cover;
  flex-shrink: 0;
`;

const Glyph = styled.svg`
  width: 52%;
  height: 52%;
`;

/**
 * 썸네일/이미지가 없을 때 보여주는 "이미지 없음" 자리표시 컴포넌트.
 *
 * 기본은 SVG 아이콘이며, 상단 PLACEHOLDER_SRC에 정적 이미지를 지정하면
 * 그 이미지로 대체된다. 표·카드 등 이미지가 없는 모든 자리에서 동일하게 재사용한다.
 *
 * @param size       한 변 크기. number(px) 또는 CSS 문자열 (기본 50)
 * @param radius     border-radius (기본 4px)
 * @param bordered   테두리 표시 여부 (기본 true). 이미 프레임이 있는 곳은 false.
 * @param color      배경색 (기본 연한 파랑)
 * @param iconColor  아이콘 색 (기본 흐린 파랑)
 * @param alt        대체 텍스트 (기본 "이미지 없음")
 */
export function EmptyImage({
  size = 50,
  radius = "4px",
  bordered = true,
  color = "#eaeff6",
  iconColor = "#9fb4d4",
  alt = "이미지 없음",
  className,
  style,
}) {
  const cssSize = toSize(size);

  if (PLACEHOLDER_SRC) {
    return (
      <Img
        src={PLACEHOLDER_SRC}
        alt={alt}
        $size={cssSize}
        $radius={radius}
        $bordered={bordered}
        className={className}
        style={style}
      />
    );
  }

  return (
    <Box
      $size={cssSize}
      $radius={radius}
      $color={color}
      $iconColor={iconColor}
      $bordered={bordered}
      role="img"
      aria-label={alt}
      className={className}
      style={style}
    >
      <Glyph viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect
          x="3"
          y="4"
          width="18"
          height="16"
          rx="2"
          stroke="currentColor"
          strokeWidth="1.6"
        />
        <circle cx="8" cy="8.5" r="1.6" fill="currentColor" />
        <path
          d="M5 18l4.5-5 3 3L16 11l3 4v3H5z"
          fill="currentColor"
          opacity="0.85"
        />
      </Glyph>
    </Box>
  );
}

export default EmptyImage;
